export default __webpack_public_path__ + "static/media/finger1.dc79d08a.png";